import configs from "@/i18n/configs"
export default {
    'add-pharmaceutical-form': `${configs.addPharmaceuticalForm.ar}`,
    'edit-pharmaceutical-form': `${configs.editPharmaceuticalForm.ar}`,
    'the-pharmaceutical-form': `${configs.thePharmaceuticalForm.ar}`
}